export default __webpack_public_path__ + "static/media/forPsych.d0e96494.png";